import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { CategoryAnalysis } from '@/components/financial/category-analysis';

export const Route = createFileRoute('/categories/analysis')({
  component: CategoryAnalysisPage,
});

function CategoryAnalysisPage() {
  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div>
          <h1 className="font-bold text-2xl tracking-tight">
            Análise de Categorias
          </h1>
          <p className="text-muted-foreground">
            Monitore os gastos por categoria e veja recomendações personalizadas
          </p>
        </div>

        <CategoryAnalysis />
      </div>
    </AuthGuard>
  );
}
